import React, { useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "@/lang";
import { initLenis } from "@/lib/lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Gallery from "@/components/Gallery";
import ServiceArea from "@/components/ServiceArea";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import FloatingBar from "@/components/FloatingBar";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center font-serif text-2xl text-navy">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

const Grain = () => (
  <div aria-hidden="true" className="grain pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-overlay" />
);

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <div className="min-h-screen overflow-x-clip bg-cream font-sans text-ink antialiased">
          <Grain />
          <Header />
          <main>
            <Hero />
            <Marquee />
            <Problem />
            <Services />
            <HowItWorks />
            <Gallery />
            <ServiceArea />
            <Faq />
            <FinalCta />
          </main>
          <Footer />
          <FloatingBar />
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
